import React from 'react';
import QuestionLearnButton from './QuestionLearnButton';

// Aggregate "learn" panel shown below complex exercise layouts (Reading 3-7,
// Listen 1/4/5) where placing the icon inline next to each question is impractical.
// Each row shows the correctness, question number, question text, and a ⓘ icon.
const ExerciseLearnPanel = ({ questions, isReviewMode }) => {
  if (!isReviewMode) return null;
  const list = (questions || []).filter((q) =>
    (q?.tag_details && q.tag_details.length > 0) ||
    q?.teacher_note?.explain_vn || q?.teacher_note?.explain_en
  );
  if (list.length === 0) return null;

  return (
    <div
      style={{
        marginTop: 24,
        background: '#FFF',
        border: '1px solid #E8E0CC',
        borderRadius: 20,
        padding: '14px 16px',
        fontFamily: '"Nunito", "Baloo 2", sans-serif',
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
        <span style={{ fontSize: 16 }}>📖</span>
        <span style={{ fontSize: 14, fontWeight: 800, color: '#2D2D2D' }}>
          Học từ các câu trong bài
        </span>
        <span style={{ fontSize: 12, color: '#9A9A9A', marginLeft: 'auto' }}>
          Bấm <strong>i</strong> để xem chi tiết
        </span>
      </div>
      {list.map((q) => {
        const isCorrect = q.is_correct === true || q.is_correct === 'true';
        return (
          <div
            key={q.id}
            style={{
              display: 'flex', alignItems: 'center', gap: 10,
              padding: '8px 0',
              borderTop: '1px dashed #E8E0CC',
            }}
          >
            <span
              style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                width: 22, height: 22, borderRadius: 999,
                background: isCorrect ? '#88C057' : '#E76F51',
                color: '#FFF', fontSize: 12, fontWeight: 900, flexShrink: 0,
              }}
            >
              {isCorrect ? '✓' : '✗'}
            </span>
            <span style={{ fontSize: 12, fontWeight: 800, color: '#6B4F2B', flexShrink: 0 }}>
              Câu {q.order_index ?? '?'}
            </span>
            <span style={{
              flex: 1, fontSize: 13, color: '#6B6B6B',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
            }}>
              {q.question_text?.replace(/\(Example\)/gi, '').trim()}
            </span>
            <QuestionLearnButton question={q} />
          </div>
        );
      })}
    </div>
  );
};

export default ExerciseLearnPanel;
